import { Avatar, Box, CssBaseline, Divider, List, ListItem, Modal, Typography } from "@mui/material"
import React from "react"
import { IJobListing } from "../../entities/job/interface"

interface IGroupJobStopProps {
    isOpen: boolean
    onClose: () => void
    groupJobs: IJobListing[][]
}

const GroupJobStops = (props: IGroupJobStopProps) => {
    const listStyles = {
        width: "100%",
        overflow: "auto",
        "&::-webkit-scrollbar": {
            display: "none",
            width: "0px",
        },
    }

    return (
        <Modal
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "transparent", // Set background to transparent
                height: "85vh",
                width: "100%",
                paddingTop: 12,
            }}
            disableAutoFocus={true}
            open={props.isOpen}
            onClose={props.onClose}
        >
            <Box
                sx={{
                    alignItems: "center",
                    width: "88%",
                    maxWidth: 700,
                    display: "flex",
                    flexDirection: "column",
                    maxHeight: "85vh",
                    marginTop: { xs: "10%", sm: "7%", md: "2.5%" },
                    paddingX: { xs: "4%", sm: "3%", md: "2%" },
                    bgcolor: "secondary.main",
                    borderRadius: 5,
                }}
                onClick={props.onClose}
            >
                <CssBaseline />
                <Box sx={listStyles}>
                    <List>
                        {props.groupJobs.map((item: IJobListing[], index: number) => {
                            const isLastItem = index === props.groupJobs.length - 1
                            const job = item[0]
                            return (
                                <ListItem
                                    key={index}
                                    disableGutters
                                    sx={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                        flexDirection: "column",
                                    }}
                                >
                                    <Box
                                        width={"100%"}
                                        height={"100%"}
                                        display="flex"
                                        flexDirection="row"
                                        alignItems={"center"}
                                    >
                                        <Avatar
                                            sx={{
                                                height: { xs: "50px", sm: "60px", md: "70px" },
                                                width: { xs: "50px", sm: "60px", md: "70px" },
                                                marginRight: 2,
                                                boxShadow: 15,
                                                backgroundColor:
                                                    job.type === "pickup" ? "primary.main" : "warning.main",
                                            }}
                                        >
                                            {item.length > 1 && (
                                                <Typography variant="h5" color={"white"}>
                                                    {item.length}
                                                </Typography>
                                            )}
                                            <Typography variant="h5" color={"white"}>
                                                {job.type === "pickup" ? "P" : "D"}
                                            </Typography>
                                        </Avatar>
                                        <Box display={"flex"} flexDirection={"column"}>
                                            <Typography variant="h6" color={"white"}>
                                                {job.type === "pickup"
                                                    ? job.originAddress?.address
                                                    : job.destinationAddress?.address}
                                            </Typography>
                                            <Typography variant="subtitle1" color={"white"}>
                                                {job.type === "pickup" ? job.origin?.company : job.origin?.company}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    {/* Only show the Divider if it's not the last item */}
                                    {!isLastItem && (
                                        <Divider
                                            sx={{
                                                width: "100%",
                                                marginTop: "5%",
                                                borderBottomWidth: "1.5px",
                                                borderColor: "white",
                                            }}
                                        />
                                    )}
                                </ListItem>
                            )
                        })}
                    </List>
                </Box>
            </Box>
        </Modal>
    )
}

export default GroupJobStops
